import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./AboutMePhoneScreen.scss";
import Loader from "../../../../components/Loader/Loader";

const AboutMePhoneScreen = () => {
  const [isBasicOpen, setIsBasicOpen] = useState(true);
  const [isContactOpen, setIsContactOpen] = useState(true);
  const [isMembershipOpen, setIsMembershipOpen] = useState(true);
  const [user, setUser] = useState({});
  const [loadingUser, setLoadingUser] = useState(false);
  const navigate = useNavigate();

  const fetchUserDetails = useCallback(async () => {
    setLoadingUser(true);
    const url = `https://ballersapi.ballerslife.co/api/v1/memberships/get_member_details`;
    const accessToken = window.localStorage.getItem("access_token");

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();
      if (response.status === 200) {
        setUser({
          name: data.member_name,
          dob: data.DOB,
          location: `${data.city || "Unknown"}, ${data.country || ""}`,
          profession: data.member_work_profile,
          email: data.email_id,
          mobileNumber: `${data.country_code || ""} ${data.phone_no || ""}`,
          memberId: data.member_id,
          profileImage: data.member_profile_pic_url,
          memberPlan: data.membership_plan || "N/A",
          memberExpires: data.membership_end_date || "N/A",
        });
      } else if (response.status === 403) {
        window.localStorage.removeItem("access_token");
        window.localStorage.removeItem("flag");
        navigate("/login");
        window.location.reload();
      } else {
        // toast.error(data.detail || "Failed to fetch user details.");
      }
    } catch (err) {
      // toast.error("An error occurred while fetching user details.");
    } finally {
      setLoadingUser(false);
    }
  }, [navigate]);

  useEffect(() => {
    fetchUserDetails();
  }, [fetchUserDetails]);

  if (loadingUser) {
    return <Loader />;
  }

  return (
    <>
      <div className="header-container">
        <span className="back-icon" onClick={() => navigate(-1)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#FFB000"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </span>
        <h2 className="section-title">ABOUT ME</h2>
        <span className="threeDots-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-ellipsis-vertical-icon lucide-ellipsis-vertical"
          >
            <circle cx="12" cy="12" r="1" />
            <circle cx="12" cy="5" r="1" />
            <circle cx="12" cy="19" r="1" />
          </svg>
        </span>
      </div>
      <div className="mobProfile-screen">
        <div className="mobProfile-image">
          <img
            src={user.profileImage || "https://via.placeholder.com/150"}
            alt="Profile"
          />
        </div>

        <div className="mobProfile-section-aboutMe">
          <div
            className="mobProfile-section-header"
            onClick={() => setIsBasicOpen(!isBasicOpen)}
          >
            <h2>Basic Details</h2>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={`mobProfile-chevron ${isBasicOpen ? "open" : ""}`}
            >
              <path d="m18 15-6-6-6 6" />
            </svg>
          </div>
          {isBasicOpen && (
            <div className="mobProfile-section-content">
              <div className="mobProfile-row">
                <span className="mobProfile-label-aboutMe">Name</span>
                <span className="mobProfile-value">{user.name}</span>
              </div>
              <div className="mobProfile-row">
                <span className="mobProfile-label-aboutMe">DOB</span>
                <span className="mobProfile-value">{user.dob}</span>
              </div>
              <div className="mobProfile-row">
                <span className="mobProfile-label-aboutMe">Location</span>
                <span className="mobProfile-value">{user.location}</span>
              </div>
              <div className="mobProfile-row">
                <span className="mobProfile-label-aboutMe">Profession</span>
                <span className="mobProfile-value">{user.profession}</span>
              </div>
            </div>
          )}
        </div>

        <div className="mobProfile-section">
          <div
            className="mobProfile-section-header"
            onClick={() => setIsContactOpen(!isContactOpen)}
          >
            <h2>Contact Details</h2>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={`mobProfile-chevron ${isContactOpen ? "open" : ""}`}
            >
              <path d="m18 15-6-6-6 6" />
            </svg>
          </div>
          {isContactOpen && (
            <div className="mobProfile-section-content">
              <div className="mobProfile-row">
                <span className="mobProfile-label-aboutMe">Email</span>
                <span className="mobProfile-value">{user.email}</span>
              </div>
              <div className="mobProfile-row">
                <span className="mobProfile-label-aboutMe">Mobile Number</span>
                <span className="mobProfile-value">{user.mobileNumber}</span>
              </div>
            </div>
          )}
        </div>

        <div className="mobProfile-section">
          <div
            className="mobProfile-section-header"
            onClick={() => setIsMembershipOpen(!isMembershipOpen)}
          >
            <h2>Membership Details</h2>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={`mobProfile-chevron ${isMembershipOpen ? "open" : ""}`}
            >
              <path d="m18 15-6-6-6 6" />
            </svg>
          </div>
          {isMembershipOpen && (
            <div className="mobProfile-section-content">
              <div className="mobProfile-row">
                <span className="mobProfile-label-aboutMe">Member ID</span>
                <span className="mobProfile-value">{user.memberId}</span>
              </div>
              <div className="mobProfile-row">
                <span className="mobProfile-label-aboutMe">Member Plan</span>
                <span className="mobProfile-value">{user.memberPlan}</span>
              </div>
              <div className="mobProfile-row">
                <span className="mobProfile-label-aboutMe">Member Expires</span>
                <span className="mobProfile-value">{user.memberExpires}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AboutMePhoneScreen;
